export default __webpack_public_path__ + "static/media/Ek.c07a7312.gif";